module.exports = __webpack_public_path__ + "static/media/11.30728309.jpg";